export default __webpack_public_path__ + "static/colours-red-1280x800-c697fc823e9a40dd86a7589cafca4ae7.jpg";